import { ReactNode, useState } from "react";
import { displayMediaObjectStyles } from "./displayMediaObjectStyle";
import IconButton from "@mui/material/IconButton";
import { ArrowBackIos, ArrowForwardIos, RotateLeft, RotateRight } from "@mui/icons-material";
import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import { Box, Grid, Stack } from "@mui/material";
import _ from "lodash";
import DisplayMediaObjectContent from "./DisplayMediaObjectContent";
import { MediaObject } from "../../types/MediaObject";
import { ExternalReferenceFile } from "../../types/ExternalReferenceFile";

type DisplayMediaObjectProps = {
  mediaObject?: MediaObject | ExternalReferenceFile["mediaObjects"][number] | null;
  closeDialog: Function;
  switchImage?: Function;
  hasPreviousImage?: boolean;
  hasNextImage?: boolean;
  titleElement?: ReactNode;
};

const DisplayMediaObject = ({
  mediaObject,
  closeDialog,
  switchImage = () => {},
  hasPreviousImage = false,
  hasNextImage = false,
  titleElement,
}: DisplayMediaObjectProps) => {
  const [mediaRotation, setMediaRotation] = useState(0);

  if (!mediaObject) {
    return null;
  }
  const rotateMedia = (direction: string) => {
    if (direction === "clockwise") {
      if (mediaRotation > 270) {
        setMediaRotation(90);
        return;
      }
      setMediaRotation(mediaRotation + 90);
    }
    if (direction === "counterclockwise") {
      if (mediaRotation < 90) {
        setMediaRotation(270);
        return;
      }
      setMediaRotation(mediaRotation - 90);
    }
  };

  return (
    <LegalbirdIoModal
      handleClose={closeDialog}
      open={!!mediaObject}
      title={
        <Stack
          direction={"row"}
          sx={{
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          {_.truncate(mediaObject.description || "", { length: 50 })}
          {titleElement && <> {titleElement}</>}
        </Stack>
      }
      hasActions={false}
      maxWidth={"md"}
      submitButton={null}
    >
      <Box sx={displayMediaObjectStyles.imageDialog}>
        {(hasNextImage || hasPreviousImage) && (
          <Grid container>
            <Grid size={12}>
              <IconButton onClick={() => switchImage("previous")} disabled={!hasPreviousImage} size="large">
                <ArrowBackIos />
              </IconButton>
              <IconButton onClick={() => switchImage("next")} disabled={!hasNextImage} size="large">
                <ArrowForwardIos />
              </IconButton>
            </Grid>
          </Grid>
        )}
        <Box sx={displayMediaObjectStyles.imageContainer}>
          <DisplayMediaObjectContent mediaObject={mediaObject} mediaRotation={mediaRotation} />
        </Box>
        <Box sx={displayMediaObjectStyles.buttonContainer}>
          <IconButton onClick={() => rotateMedia("counterclockwise")} size="large">
            <RotateLeft />
          </IconButton>
          <IconButton onClick={() => rotateMedia("clockwise")} size="large">
            <RotateRight />
          </IconButton>
        </Box>
      </Box>
    </LegalbirdIoModal>
  );
};

export default DisplayMediaObject;
